<template>
  <div>
    <div style="display: flex">
      <i
        class="fa fa-filter color-darkBlue"
        style="font-size: 18px;display: flex;align-items: center;"
        aria-hidden="true"
      ></i>
      <Typography h3 semiBold label="Advanced Search" class="pl-1" />
    </div>
    <v-layout wrap v-if="!hideMain" class="mt-2">
      <v-flex xs12 sm12 class="form-control pa-1" v-if="filterType !== 'boardcast'">
        <!-- <label for>{{ $t('Account Name') }}</label> -->
        <Typography h5 semiBold :label="$t('Account Name')" />
        <input
          type="text"
          :placeholder="$t('Account Name')"
          v-model.lazy="filter.fullname"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm6 class="form-control pa-1">
        <!-- <label for>{{ $t('Channel') }}</label> -->
        <Typography h5 semiBold :label="$t('Channel')" />
        <multiselect
          v-model="filter.app"
          :options="channelOptions"
          label="label"
          selectLabel
          selectedLabel
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
        ></multiselect>
      </v-flex>
      <!-- <v-flex xs12 sm6 class="form-control pa-1">
        <Typography h5 semiBold :label="$t('gender')" />
        <multiselect
          v-model="filter.gender"
          :options="genderOptions"
          label="label"
          selectLabel
          selectedLabel
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
        ></multiselect>
      </v-flex> -->
      <!-- <v-flex xs12 sm6 class="form-control pa-1">
        <Typography h5 semiBold :label="$t('Locale')" />
        <multiselect
          v-model="filter.locale"
          :options="langFilter"
          label="title"
          selectLabel
          selectedLabel
          deselect-label
          track-by="value"
          :multiple="true"
          :placeholder="$t('Locale')"
          class="multi-tag-small"
        >
          <template slot="option" slot-scope="props">
            <flag :iso="props.option.icon" />

            {{ props.option.title }}
          </template>
        </multiselect>
      </v-flex> -->
      <!-- <v-flex xs12 sm6 md6 class="form-control pa-1">
        <Typography h5 semiBold :label="$t('Context')" />
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <input
            type="text"
            class="form-control"
            name="Context"
            data-vv-name="Context"
            :data-vv-as="$t('Context')"
            :placeholder="$t('Context')"
            v-model.lazy="filter.context"
          />

          <p class="text-error" v-if="errors.has('Context')">{{ errors.first('Context') }}</p>
        </div>
      </v-flex> -->
      <v-flex xs12 sm12>
        <div>
          <!-- <label for>{{ $t('First Conversation at') }}</label> -->
          <Typography h5 semiBold :label="$t('First Conversation at')" />
        </div>
        <template>
          <v-layout>
            <v-flex class="pa-1">
              <!-- <VueDatePicker
                v-model="filter.registerDate.start"
                @selected="onRegisterStartDate"
                :placeholder="$t('from')"
              /> -->
              <div class="form-control">
                <date-picker
                  :append-to-body="false"
                  :clearable="true"
                  :editable="false"
                  input-class="dateSearch"
                  name="DateSearch"
                  v-model="filter.registerDate.start"
                  valueType="date"
                  format="DD/MM/YYYY"
                  :placeholder="$t('from')"
                  :confirm="onRegisterStartDate"
                >
                  <template v-slot:footer="{ emit }">
                    <div style="text-align: left">
                      <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
                    </div>
                  </template>
                </date-picker>
              </div>
            </v-flex>
            <v-flex  class="pa-1">
              <!-- <datepicker
                v-model="filter.registerDate.end"
                style
                @selected="onRegisterEndDate"
                :placeholder="$t('to')"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
              ></datepicker> -->
              <!-- <VueDatePicker
                v-model="filter.registerDate.end"
                @selected="onRegisterEndDate"
                :placeholder="$t('to')"
              /> -->
              <div class="form-control">
                <date-picker
                  :append-to-body="false"
                  :clearable="true"
                  :editable="false"
                  input-class="dateSearch"
                  name="DateSearch"
                  v-model="filter.registerDate.end"
                  valueType="date"
                  format="DD/MM/YYYY"
                  :placeholder="$t('to')"
                  :confirm="onRegisterEndDate"
                >
                  <template v-slot:footer="{ emit }">
                    <div style="text-align: left">
                      <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
                    </div>
                  </template>
                </date-picker>
              </div>
            </v-flex>
          </v-layout>
        </template>
      </v-flex>
      <!-- <v-flex xs12 sm12>
        <VueDatePicker v-model="filter.activeDate.start" @selected="onActiveStartDate" />
      </v-flex> -->
      <v-flex xs12 sm12>
        <div>
          <!-- <label for>{{ $t('Last Conversation at') }}</label> -->
          <Typography h5 semiBold :label="$t('Last Conversation at')" />
        </div>
        <template>
          <v-layout>
            <v-flex class="pa-1">
              <!-- <VueDatePicker
                v-model="filter.activeDate.start"
                @selected="onActiveStartDate"
                :placeholder="$t('from')"
                :locale="{ lang: 'en' }"
              /> -->
              <div class="form-control">
                <date-picker
                  :append-to-body="false"
                  :clearable="true"
                  :editable="false"
                  input-class="dateSearch"
                  name="DateSearch"
                  v-model="filter.activeDate.start"
                  valueType="date"
                  format="DD/MM/YYYY"
                  :placeholder="$t('from')"
                  :confirm="onActiveStartDate"
                >
                  <template v-slot:footer="{ emit }">
                    <div style="text-align: left">
                      <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
                    </div>
                  </template>
                </date-picker>
              </div>

              <!-- <datepicker
                v-model="filter.activeDate.start"
                @selected="onActiveStartDate"
                :placeholder="$t('from')"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
              ></datepicker> -->
            </v-flex>
            <v-flex class="pa-1">
              <!-- <VueDatePicker
                v-model="filter.activeDate.end"
                @selected="onActiveEndDate"
                :placeholder="$t('to')"
                :locale="{ lang: 'en' }"
              /> -->
              <div class="form-control">
                <date-picker
                  :append-to-body="false"
                  :clearable="true"
                  :editable="false"
                  input-class="dateSearch"
                  name="DateSearch"
                  v-model="filter.activeDate.end"
                  valueType="date"
                  format="DD/MM/YYYY"
                  :placeholder="$t('to')"
                  :confirm="onActiveEndDate"
                >
                  <template v-slot:footer="{ emit }">
                    <div style="text-align: left">
                      <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
                    </div>
                  </template>
                </date-picker>
              </div>
              <!-- <datepicker
                v-model="filter.activeDate.end"
                style
                @selected="onActiveEndDate"
                :placeholder="$t('to')"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
              ></datepicker> -->
            </v-flex>
          </v-layout>
        </template>
      </v-flex>

      <!-- <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>Message Symbol</label>
        <v-radio-group v-model="filter.messagesent.symbol" row style="margin-top: 5px;">
          <v-radio
            :label="$t('Greater than')"
            :value="{ value: 'g__', label: $t('Greater than')}"
            color="primary"
          ></v-radio>
          <v-radio
            :label="$t('Less than')"
            :value="{value: 'l__',  label: $t('Less than')}"
            color="primary"
          ></v-radio>
        </v-radio-group>
      </v-flex>-->
      <!-- <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>{{$t('Message Sent')}}</label>
        <div
          class="form-inline form-control"
          :class="{'has-error': errors.has('filterMessageSentFrom') || errors.has('filterMessageSent')}"
        >
          <input
            type="text"
            class="form-control"
            name="filterMessageSent"
            data-vv-name="filterMessageSent"
            :data-vv-as="$t('Message Sent')"
            :placeholder="$t('Message Sent')"
            v-model="filter.messagesent.value"
            v-validate="'numeric'"
          />

          <p
            class="text-error"
            v-if="errors.has('filterMessageSentFrom')"
          >{{ errors.first('filterMessageSentFrom') }}</p>
          <p
            class="text-error"
            v-else-if="errors.has('filterMessageSent')"
          >{{ errors.first('filterMessageSent') }}</p>
        </div>
      </v-flex>-->

      <v-flex xs12 class="form-control pa-1">
        <v-layout row wrap>
          <v-flex xs12 class="mt-3">
            <!-- <div style="color: #152d53; font-weight: 500; font-size: 19px">ข้อมูลสมาชิก</div> -->
            <Typography h3 semiBold label="ข้อมูลสมาชิก" />
          </v-flex>
          <v-flex xs6 class="form-control pa-1" v-if="filterType !== 'boardcast'">
            <!-- <label>{{ $t('ชื่อสมาชิก') }}</label> -->
            <Typography h5 semiBold :label="$t('ชื่อสมาชิก')" />
            <div
              class="form-inline form-control"
              :class="{ 'has-error': errors.has('ชื่อสมาชิก') }"
            >
              <input
                type="text"
                class="form-control"
                name="ชื่อสมาชิก"
                data-vv-name="ชื่อสมาชิก"
                :data-vv-as="$t('ชื่อสมาชิก')"
                :placeholder="$t('ชื่อสมาชิก')"
                v-model.lazy="filter.membername"
              />

              <p class="text-error" v-if="errors.has('ชื่อสมาชิก')">
                {{ errors.first('ชื่อสมาชิก') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs6 class="pa-1">
            <!-- <label>{{ $t('ประเภทสมาชิก') }}</label> -->
            <Typography h5 semiBold :label="$t('ประเภทสมาชิก')" />
            <div
              class="form-inline form-control"
              :class="{ 'has-error': errors.has('ประเภทสมาชิก') }"
            >
              <multiselect
                v-model="filter.membertype_id"
                :options="customerMembertypeOptions.map(item => item.typeid)"
                :custom-label="
                  opt =>
                    customerMembertypeOptions.find(x => x.typeid == opt)
                      ? customerMembertypeOptions.find(x => x.typeid == opt).type
                      : false
                "
                :custom-track-by="
                  opt => customerMembertypeOptions.find(x => x.typeid == opt).typeid
                "
                :searchable="false"
                deselect-label=""
                :allow-empty="false"
                single-select
              ></multiselect>
              <p class="text-error" v-if="errors.has('ประเภทสมาชิก')">
                {{ errors.first('ประเภทสมาชิก') }}
              </p>
            </div>
          </v-flex>
          <!-- <v-flex xs12 sm6 class="form-control pa-1">
            <Typography h5 semiBold :label="$t('Email')" />
            <input
              type="text"
              :placeholder="$t('Email')"
              v-model.lazy="filter.email"
              class="form-control"
              maxlength="255"
            />
          </v-flex> -->
          <!-- <v-flex xs12 sm6 class="form-control pa-1">
            <Typography h5 semiBold :label="$t('phone no.')" />
            <input
              type="text"
              placeholder="Phone No"
              v-model.lazy="filter.phoneno"
              class="form-control"
              maxlength="255"
            />
          </v-flex> -->

          <v-flex xs6 class="pa-1">
            <!-- <label>{{ $t('Project') }}</label> -->
            <Typography h5 semiBold :label="$t('Project')" />
            <div class="form-inline form-control" :class="{ 'has-error': errors.has('Project') }">
              <multiselect
                v-model="filter.projectname"
                :options="customerProjectOptions"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
              ></multiselect>

              <p class="text-error" v-if="errors.has('Project')">{{ errors.first('Project') }}</p>
            </div></v-flex
          >
          <v-flex xs6 class="pa-1">
            <!-- <label>{{ $t('Project type') }}</label> -->
            <Typography h5 semiBold :label="$t('Project type')" />
            <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
              <multiselect
                v-model="filter.projecttype"
                :options="projectTypeOptions"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
              ></multiselect>

              <p class="text-error" v-if="errors.has('Province')">{{ errors.first('Province') }}</p>
            </div>
          </v-flex>
          <v-flex xs6 class="pa-1">
            <!-- <label>{{ $t('Status') }}</label> -->
            <Typography h5 semiBold :label="$t('Status')" />
            <div class="form-inline form-control" :class="{ 'has-error': errors.has('Status') }">
              <multiselect
                v-model="filter.memberstatus"
                :options="customerStatusOptions"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
                :customLabel="customLabelMemberStatus"
              >
              </multiselect>

              <p class="text-error" v-if="errors.has('Status')">{{ errors.first('Status') }}</p>
            </div></v-flex
          >
          <v-flex xs6 class="pa-1">
            <!-- <label>{{ $t('DP type') }}</label> -->
            <Typography h5 semiBold :label="$t('DP type')" />
            <div class="form-inline form-control" :class="{ 'has-error': errors.has('DP type') }">
              <multiselect
                v-model="filter.dpType"
                :options="['DP', 'Non-DP']"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
              >
              </multiselect>

              <p class="text-error" v-if="errors.has('DP type')">{{ errors.first('DP type') }}</p>
            </div></v-flex
          >
        </v-layout>
      </v-flex>
      <!-- 
      <v-flex xs12>
        <div style="color: #152d53; font-weight: 500; font-size: 19px">ประเภทสมาชิก</div>
      </v-flex>
      <v-flex xs4 class="pa-1 mb-4">
        <label>{{ $t('Verification') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <multiselect
            v-model="filter.verification"
            :options="$store.state.depamembertype"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
          ></multiselect>

          <p class="text-error" v-if="errors.has('Province')">{{ errors.first('Province') }}</p>
        </div>
      </v-flex> -->
      <v-flex xs12 class="form-control pa-1" :class="{ 'has-error': errorFilterTag.length > 0 }">
        <!-- <label for>{{ $t('Tag') }}</label> -->
        <Typography h5 semiBold :label="$t('Tag')" />
        <tags
          v-model="tag"
          :tags="tags"
          @tags-changed="addTags"
          @before-adding-tag="checkTag"
          style="margin-bottom: 10px"
          :btnText="$t('Add tag')"
          :isDrag="false"
        ></tags>

        <span class="text-error" v-if="errorFilterTag.length > 0">
          <template v-if="errorFilterTag.includes('overmaxlength')">{{
            $t('Message cannot be longer than 20 alphabets')
          }}</template>
          <template v-else-if="errorFilterTag.includes('duplicate')">{{
            $t('Duplicate Tag')
          }}</template>
        </span>
      </v-flex>
      <!-- <v-flex xs12 class="form-control pa-1">
        <Typography h5 semiBold :label="$t('Status')" />
        <v-radio-group color="primary" v-model="filter.statustype" row class="text-xs-center">
          <v-radio color="primary" :label="$t('Includes')" :value="'includes'"></v-radio>
          <v-radio color="primary" :label="$t('Excludes')" :value="'excludes'"></v-radio>
        </v-radio-group>
        <multiselect
          v-model="filter.status"
          :options="userStatus"
          :searchable="true"
          selectLabel
          selectedLabel
          deselect-label
          :multiple="true"
          :placeholder="$t('Status')"
          @select="$emit('onChangeStatus')"
          @remove="$emit('onChangeStatus')"
          class="multi-tag-small"
        ></multiselect>
      </v-flex> -->
    </v-layout>
    <slot name="append" :filter="filter"></slot>
    <div class="text-xs-right pa-1">
      <slot></slot>
      <!-- <v-flex xs12 class="pa-1 mt-1">
        <div
          style="text-align: right; color: black; font-size: 1.1em"
        >{{$t('Total')}}: {{total_user}}</div>
      </v-flex>-->
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
// import datepicker from 'vuejs-datepicker'
import Tags from '@/components/elements/Tags'
import Typography from '@/components/elements/Typography.vue'
// import { VueDatePicker } from '@mathieustan/vue-datepicker'
import DatePicker from 'vue2-datepicker'
export default {
  props: {
    value: {
      default: undefined
    },
    hideMain: {
      default: false
    },
    filterType: {
      default: null
    }
  },
  components: {
    Multiselect,
    // datepicker,
    Tags,
    Typography,
    DatePicker
  },

  mounted: function() {
    this.getIntent()
    this.getdepaproject()
    this.getdepamembertypeall()
    this.getProjectType()
    //this.$emit('onUpdate')
  },
  data: function() {
    return {
      customerStatusOptions: ['confirm', 'unconfirmed'],
      customerProjectOptions: [],
      customerMembertypeOptions: [],
      isLoading: false,
      filter: this.value,
      channelOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Line'),
          value: 'line'
        }
      ],
      genderOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Male'),
          value: 'male'
        },
        {
          label: this.$t('Female'),
          value: 'female'
        },
        {
          label: this.$t('no gender'),
          value: 'other'
        }
      ],
      specialconditionOptions: [
        {
          label: this.$t('Active Users'),
          value: 'activeusers'
        },
        {
          label: this.$t('Potential Users'),
          value: 'potentialusers'
        },
        {
          label: this.$t('Purchased Users'),
          value: 'perchasedusers'
        },
        {
          label: this.$t('Loyal Customer'),
          value: 'perchasedusers_royalty'
        },
        {
          label: this.$t('New Customer'),
          value: 'perchasedusers_newcomer'
        }
      ],
      localeOptions: config.locale,
      symbolOptions: [
        {
          value: 'g__',
          label: this.$t('Greater than')
        },
        {
          value: 'l__',
          label: this.$t('Less than')
        },
        {
          value: 'n__',
          label: this.$t('Not')
        }
      ],
      intents: [],
      errorFilterTag: [],
      tag: '',
      depaprojects: [],
      projectTypeOptions: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus'
    }),
    langFilter() {
      if (this.filterType === 'boardcast') {
        let data = [
          {
            title: 'Thai',
            value: 'th_TH',
            icon: 'th'
          },
          {
            title: 'English (US)',
            value: 'en_US',
            icon: 'us'
          }
        ]
        return data
      } else {
        return config.locale
      }
    },
    filterIntent: function() {
      var vm = this
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents = []
      $.each(vm.intents, function(index, intent) {
        intents.push(intent.intentname)
      })
      return intents
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    }
  },

  methods: {
    customLabelMemberStatus(opt) {
      if (opt == 'confirm') return 'ยืนยันตัวตนแล้ว'
      else if (opt == 'unconfirmed') return 'ยังไม่ยืนยันตัวตน'
    },
    getProjectType() {
      return new Promise(resolve => {
        api.getdepaprojecttype(this.search, (err, response) => {
          if (response.responsecode == 200) {
            this.projectTypeOptions = response.data.map(el => {
              return el.typename
            })
          }
          resolve()
        })
      })
    },
    getdepamembertypeall() {
      api.getdepamembertypeall({ pageid: this.selectedBot.pageid }, (err, response) => {
        if (response.responsecode == 200) {
          this.customerMembertypeOptions = response.data
        }
      })
    },
    getdepaproject() {
      return new Promise(resolve => {
        api.getdepaproject({}, (err, response) => {
          if (response.responsecode == 200) {
            this.customerProjectOptions = response.data.map(el => el.projectname)
          }
          resolve()
        })
      })
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 9999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function(newTags) {
      this.tags = newTags
    },
    getIntent: function(callback) {
      let vm = this
      let auth = null
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid
        }
        api.getIntent(data, function(error, response) {
          if (error) {
            console.error(error)
            reject(error)
          }
          if (response.data) {
            var isFoundDefault = false
            var intents = []
            $.each(response.data, function(index, val) {
              var intent = val
              intent.isShow = false
              intents.push(intent)
            })
            vm.intents = intents
          }
          resolve()
        })
      })
    },
    onActiveStartDate: function(value) {
      var vm = this
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
      this.$emit('onUpdate')
    },
    onActiveEndDate: function(value) {
      var vm = this
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
      this.$emit('onUpdate')
    },
    onRegisterStartDate: function(value) {
      var vm = this
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
      this.$emit('onUpdate')
    },
    onRegisterEndDate: function(value) {
      var vm = this
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
      this.$emit('onUpdate')
    }
  },
  watch: {
    value: function(newVal) {
      this.filter = newVal
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/FilterCustomer.vue